import EndpointPlugin from "components/apiDocs/EndpointPlugin/EndpointPlugin";
import { useSwaggerFile } from "contexts/SwaggerFileContext";
import { Endpoint } from "models/apiDocumentation/apiDocumentationModels";
import SwaggerUI from "swagger-ui-react";

import { StyledBody } from "./style";

interface Props {
  endpointData: Endpoint;
}

const EndpointPage: React.FC<Props> = ({ endpointData }) => {
  const { data: swaggerFile } = useSwaggerFile();
  // Passing in url="" to the SwaggerUI component to avoid a null reference error within SwaggerUI throwing console errors.
  // See comment on https://github.com/swagger-api/swagger-ui/issues/8273
  return (
    <StyledBody className="container" data-test-id="endpoint-details-container">
      <SwaggerUI
        key={endpointData.url}
        spec={JSON.stringify(swaggerFile)}
        url=""
        docExpansion={"full"}
        plugins={[EndpointPlugin({ endpointData })]}
        layout={endpointData.url}
      />
    </StyledBody>
  );
};

export default EndpointPage;
